import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const partnerService = {
    getPartners : (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PARTNERS}`)
    },
    addOrRemoveSelectedPartner: (companyId, partnerId, addRemove) => {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PARTNERS}/${partnerId}/${addRemove}`)
    },
    getPartnerConnections: (companyId) => {   
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONNECTIONS}`)
    },
    deletePartnerConnection: (companyId, connectionId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONNECTIONS}/${API_PATH.DELETE}/${connectionId}`)
    },
    createPartnerConnection: (companyId, payload) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONNECTIONS}`, payload);
    },
    updatePartnerConnection: (companyId, partnerConnectionId, payload) => {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONNECTIONS}/${partnerConnectionId}`, payload);
    },
    resetAllConnectionselectedincspAs0: (companyId) => {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CONNECTIONS}`)
    },
}

export default partnerService;
